import { ValidatorService } from './../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Globals} from './../../../services/tools/Globals.service';
declare var $;

@Component({
  selector: 'app-security-modal',
  templateUrl: './security-modal.component.html',
  styleUrls: ['./security-modal.component.scss']
})
export class SecurityModalComponent implements OnInit {

  @Input() private callback: string;
  public loading;
  private password: string;
   falsoPositivo: any;
  @Input() private passwordActivated: any;
  @Output() private passwordActiv:any;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(private globals: Globals) {
      this.falsoPositivo = false;
   }

  ngOnInit() {
    this.passwordActiv = this.passwordActivated;
  }

  reset() {
    this.falsoPositivo = false;
    this.password = '';
  }

  emit() {
    this.goToCallback.emit(this.password);
  }

  close(){
    $('#security-modal').modal('hide');
  }

  open() {
    this.reset();
    $('#security-modal').modal('show');
    setTimeout(()=>{ // waiting to load fine
      document.getElementById('securityPassword').focus();
      console.log('native focus', document.getElementById('securityPassword'));
    },500);
  }

  fill(data) {
    this.callback = data.callback;
    this.passwordActivated = data.passwordActivated;
  }

  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  lock() {
    this.falsoPositivo = true;
  }

  accept() {
    if (this.falsoPositivo) {
      this.close();
      return false;
    }

    this.emit();
    //Siempre cerrar el modal después de enviar
    this.close();
  }

  push(data){
    this.fill(data);
    this.globals.passwordActivate = this.passwordActivated;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/partials/security-modal/security-modal.component.ts